export default __webpack_public_path__ + "static/media/store03_alpha.77784fc3.jpg";